<template>
  <div>
    <a-form-model layout="inline" ref="form" :model="form">
      <a-form-model-item prop="title">
        <a-input @keyup.enter.native="handleSearch" placeholder="石材标题" v-model="form.title" allowClear />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" @click="handleSearch">
          搜索
        </a-button>
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="handleResetSearchForm">
          重置
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',

  props: {
    form: { type: Object, required: true }
  },

  methods: {
    // 搜索
    handleSearch () {
      this.$emit('search')
    },

    // 重置搜索
    handleResetSearchForm () {
      this.$refs.form.resetFields()
      this.handleSearch()
    }
  }
}
</script>

<style scoped>
</style>
